import { render } from "./6OfferSection.vue?vue&type=template&id=2e6d4fa8&scoped=true"
import script from "./6OfferSection.vue?vue&type=script&lang=js"
export * from "./6OfferSection.vue?vue&type=script&lang=js"

import "./6OfferSection.vue?vue&type=style&index=0&id=2e6d4fa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6d4fa8"]])

export default __exports__